export { default } from './SkeletonLowestRatesProperties';
